module.exports = __webpack_public_path__ + "img/user-profile-placeholder.02c069ad.png";